<template>
  <a
    v-bind="{'xlink:href': link }"
  >
    <polygon
      v-if="shape.polygon"
      :key="'polygon-' + shape.id"
      :points="shape.polygon"
      :class="css"
      @mouseenter="toggleFocus(true)"
      @mouseout="toggleFocus(false)"
      @click="updateRouter"
      class="c-illustration__shape"
    />
    <path
      v-else
      :key="'path-' + shape.id"
      :d="shape.path"
      :class="css"
      @mouseenter="toggleFocus(true)"
      @mouseout="toggleFocus(false)"
      @click="updateRouter"
      class="c-illustration__shape"
    />
  </a>
</template>

<script>
import { EventBus, } from '@/event-bus.js';

// VUEX Models
import Section from '@/models/Section';
import Illustration from '@/models/Illustration';

export default {
  name: 'Shape',
  props: {
    shape: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      hasFocus: false,
    };
  },
  computed: {
    css() {
      let classes = '';
      if (this.shape.availability) {
        classes += `is-${this.shape.availability.slug}`;
      } else {
        classes += 'is-none';
      }
      if (this.hasFocus === true) {
        classes += ' has-focus';
      }
      if (this.shape.type === 'sections') {
        classes += ' is-section';
      } else if (this.shape.type === 'residences') {
        classes += ' is-residence';
      }
      return classes;
    },
    link() {
      return this.shape.url ? this.shape.url : false;
    },
  },
  created() {
    const type = this.shape.shapeable_type;
    if (type === 'residences') {
      EventBus.$on('residence-focus', focus => {
        if (focus.id === this.shape.shapeable.id) {
          this.hasFocus = focus.hasFocus;
        }
      });
    } else if (type === 'sections') {
      EventBus.$on('section-focus', focus => {
        if (focus.id === this.shape.shapeable.id) {
          this.hasFocus = focus.hasFocus;
        }
      });
    }
  },
  methods: {
    toggleFocus(focus) {
      const type = this.shape.shapeable_type;
      if (type === 'residences') {
        EventBus.$emit('residence-focus', {
          hasFocus: focus,
          id: this.shape.shapeable_id,
          name: this.shape.shapeable.name,
          illustrationIds: [],
        });
      } else if (type === 'sections') {
        EventBus.$emit('section-focus', {
          hasFocus: focus,
          id: this.shape.shapeable_id,
          name: this.shape.shapeable.name,
        });
      }
      if (type === 'residences') {
        this.scrollResidenceIntoView(this.shape.shapeable.slug);
      }
    },
    updateRouter() {
      const type = this.shape.shapeable_type;
      this.toggleFocus(false);
      if (type === 'residences') {
        this.$router.push({
          name: 'bolig',
          params: { slug: this.shape.shapeable.slug, },
        });
      } else {
        if (this.link === false) {
          this.updateSelectedSection();
        }
      }
    },
    scrollResidenceIntoView(element) {
      const residence = document.getElementById(element);
      if (residence) {
        const residenceList = document.getElementById('residenceList');
        const offset = residence.offsetTop;
        residenceList.scrollTo({ top: offset, behavior: 'smooth', });
      }
    },
    updateSelectedSection() {
      Section.commit(state => {
        state.selectedSection = this.shape.shapeable_id;
      });
      Illustration.commit(state => {
        state.currentSection = this.shape.shapeable_id;
      });
      localStorage.setItem('selectedSection', this.shape.shapeable_id);
    },
  },
};
</script>

